import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import ribbon from "../../assets/images/ribbon.png";
import $ from 'jquery';
import loading from "../../assets/images/loading-new.gif";
import { postData } from "../common/utils";
import { useAlert } from "react-alert";

const RewardHistory = () => {

    const [redeemedPats, setRedeemedPats] = useState(0);
    const [results, setResults] = useState([]);
    const alert = useAlert();

    useEffect(() => {

        fetch(process.env.REACT_APP_API_URL + "api/rewards/history")
            .then((response) => response.json())
            .then((data) => {
                if (data.issuccessful == true) {
                    //console.log(data);
                    setRedeemedPats(data.redeemed.total);
                    //console.log("paaaaaaats", redeemedPats);
                    setResults(data.rewards);
                }
            });


    }, [])

    const askUpdate = () => {
        $('.issue-btn').on('click', function () {
            $("#loader").css("display", "block");
            var id = $(this).data('id');
            var email = $(this).data('email');
            var name = $(this).data('name');
            var gc = $(this).data('gc');
            var status = $(this).data('status');
            //console.log("trans_id", id);
            var data = {
                TransID: id,
                useremail: email,
                username: name,
                giftcard: gc,
                status: status,
            };
            //console.log('daaaaaaaaaaaaaaaaaaaaaaata', data);
            postData(
                process.env.REACT_APP_API_URL + "api/rewards/askUpdateRequest",
                data
            ).then((data) => {
                if (data.issuccessful == true) {
                    $(`#status-${id}`).html(data.message);
                    $("#loader").css("display", "none");
                    alert.success(data.message);
                } else {
                    alert.error(data.message);
                }
            })
        })


    }

    return (
        <div style={{ position: "relative" }}>

            <div id='loader' style={{ display: "none", position: "fixed", top: "50%", left: "55%", transform: "translate(-50%,-50%)", zIndex: "1" }}>
                <img src={loading} alt="loading..." />
            </div>

            <div style={{ display: "flex" }}>
                <NavLink to={"/rewards"} style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                    <i class="fa fa-angle-left" style={{ color: "#008bff", fontSize: "30px" }}></i> <span className="back-btn">Back to Rewards</span>
                </NavLink>
            </div>

            <div className="tt-title">
                <h1 style={{ marginTop: "15px" }}>
                    You have redeemed <span> {redeemedPats == null ? 0 : redeemedPats} pats</span>
                </h1>
            </div>

            <section style={{ marginTop: "5%" }}>

                {results.map((data, index) => {

                    return (
                        <>
                            <div className="card-div" style={{ position: "relative" }}>
                                <div className="col-lg-4 col-md-6">
                                    <div style={{ boxShadow: "0px 0px 8px #00000059", borderRadius: "15px" }} key={data.RewardID}>
                                        <div className="rd-card" style={{ marginBottom: 0 }}>

                                            <div className="rd-img">
                                                <img
                                                    src={process.env.REACT_APP_REWIMG_URL + data.RewardImage}
                                                    alt="Reward Image"
                                                />
                                            </div>
                                            <div className="rd-text">
                                                <p>{data.GiftCard}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="reward-detail">
                                    <p><span>Amount:</span> {data.RewardAmount}</p>
                                    <p><span>Redeemed on:</span>  {data.created_date}</p>
                                    <button onClick={askUpdate} className={data.IsSuccessful == 1 ? 'issue-btn disableBtn' : 'issue-btn'} data-status={data.IsSuccessful} data-id={data.TransactionID} data-email={data.UserEmail} data-name={data.UserName} data-gc={data.GiftCard}>Ask for Update!</button>
                                </div>

                                <div className={data.IsSuccessful == 1 ? 'success' : 'waiting'}>{data.IsSuccessful == 1 ? 'Issued' : 'In Progress'}</div>
                            </div>
                        </>
                    );


                })

                }

                <h3 style={{ textAlign: "center", fontFamily: "poppins" }}>{results == "" ? "Sorry, No record found." : ""}</h3>
            </section>

        </div>
    );
}

export default RewardHistory;